const Nav = () => {
    return (
        <div>
            <div style={{ textAlign: "right", marginRight: "15%", marginTop: "2%", 
        marginBottom: "20px" }}>
                <a href="">About</a>
            </div>
            <hr style={{color: "grey"}}/>
        </div>

    )
}

export default Nav;